export type ThemePreference = 'light' | 'dark' | 'system';
export const THEME_KEY = 'collectr:operator:theme';
export const isThemePreference = (value: unknown): value is ThemePreference =>
  value === 'light' || value === 'dark' || value === 'system';
export function resolveTheme(preference: ThemePreference, systemDark: boolean): 'light' | 'dark' {
  return preference === 'system' ? (systemDark ? 'dark' : 'light') : preference;
}
export function readTheme(storage: Pick<Storage, 'getItem'> | undefined, key = THEME_KEY): ThemePreference {
  try {
    const value = storage?.getItem(key);
    return isThemePreference(value) ? value : 'system';
  } catch { return 'system'; }
}
export function writeTheme(storage: Pick<Storage, 'setItem'> | undefined, key: string, value: ThemePreference): void {
  try { storage?.setItem(key, value); } catch { /* In-memory preference still works. */ }
}
export function browserStorage(): Storage | undefined {
  try { return window.localStorage; } catch { return undefined; }
}
